export class CreatePendingRequests {
    constructor(pendingRequestRepository) {
      this.pendingRequestRepository = pendingRequestRepository;
    }
  
    async execute(createPendingRequest) {
      return await this.pendingRequestRepository.CreatePendingRequest(createPendingRequest);
    }
  }